export const columns = [
  {
    Header: '#Id',
    accessor: 'id',
  },
  {
    Header: 'Subject',
    accessor: 'subject'
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    disableGlobalFilter: true,
    disableSortBy: true
  },
];